export default "__VITE_ASSET__qmB2mqHYF4eX3pnYvuxGpw__"